import { createMuiTheme } from '@material-ui/core/styles';
export const styleSheet = {
  typography: {
    fontFamily: 'Roboto',
    h5: {
      fontSize: 18,
      lineHeight: 1.5,
      fontWeight: '500'
    },
    h6: {
      fontSize: 16,
      lineHeight: 1.5
    },
    body1: {
      fontSize: 14,
      lineHeight: 1.5
    },
    button: {
      fontSize: 14
    }
  },
  palette: {
    primary: {
      extraLight: 'rgba(39, 42, 107, 0.1)',
      light: 'rgba(39, 42, 107, 0.5)',
      main: '#2db3b3',
      dark: '#272a6b',
      contrastText: '#fff',
    },
    secondary: {
      light: 'rgba(253, 159, 40, 0.9)',
      extraLight: 'rgba(253, 159, 40, 0.5)',
      main: '#eeeeee',
      contrastText: '#000',
      dark: '#ff8f01',
    },
    tertiary: {
      extraLight: 'rgba(57, 183, 233, 0.1)',
      light: 'rgba(57, 183, 233, 0.5)',
      main: 'rgba(57, 183, 233, 0.9)',
      dark: '#39b7e9',
      contrastText: '#fff',
    },
    quaternary: {
      extraLight: 'rgba(0, 0, 0, 0.1)',
      light: 'rgba(0, 0, 0, 0.5)',
      main: 'rgba(0, 0, 0, 0.9)',
      dark: '#000000',
      contrastText: '#fff',
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },
}
export const theme = createMuiTheme(styleSheet);

